import React, { useEffect, useState } from 'react';
import Card from '../layout/Card';
import { get, post } from '../utils/fetcher';

const NOTIF_GROUPS = [
    {
        key: 'sport', label: 'Sport', types: [
            { key: 'chaine_coupe', label: 'Chaîne coupée' },
            { key: 'chaine_restart', label: 'Chaîne relancée' },
        ]
    },
    {
        key: 'streaming', label: 'Streaming', types: [
            { key: 'chaine_coupe', label: 'Chaîne coupée' },
            { key: 'chaine_restart', label: 'Chaîne relancée' },
        ]
    },
]

const WidgetNotifPrefs = () => {
    const [prefs, setPrefs] = useState({})

    useEffect(() => {
        get('/notif/prefs').then((res) => {
            if (res && typeof res === 'object') setPrefs(res)
        })
    }, [])

    const isOn = (g, t) => !!prefs?.[g]?.[t]

    const toggle = (g, t) => {
        const next = { ...prefs, [g]: { ...(prefs[g] || {}), [t]: !isOn(g, t) } }
        setPrefs(next)
        post('/notif/prefs', { prefs: next })
    }

    return (
        <Card>
            <p className='fb cw fs1 mb2'>Notifications à recevoir</p>
            {NOTIF_GROUPS.map(g => (
                <div key={g.key} className='mb2'>
                    <p className='fr cw fs12 mb1' style={{ opacity: 0.65 }}>{g.label}</p>
                    <div className='df fdc gap1'>
                        {g.types.map(t => (
                            <div key={t.key} className='df aic jcsb'>
                                <p className='fr cw fs12'>{t.label}</p>
                                <button onClick={() => toggle(g.key, t.key)} className={`btn ${isOn(g.key, t.key) ? "cs" : "cw"} `} style={{ minWidth: "90px" }}>
                                    {isOn(g.key, t.key) ? "Activé" : "Off"}
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </Card>
    );
};

export default WidgetNotifPrefs;
